import { IRtnTripAsNumber } from '@/types/logs'

export const formatTripValues = (trips: IRtnTripAsNumber[]): string => {
    if (trips.length === 0) return ''

    const sortedTrips = trips.sort((a, b) => a.order - b.order)

    const isConsecutive = sortedTrips.every((trip, index) => {
        if (index === 0) return true
        return trip.order === sortedTrips[index - 1].order + 1
    })

    if (isConsecutive && sortedTrips.length > 1) {
        // Format: [first trip]-[last trip]
        return `${sortedTrips[0].trip}-${sortedTrips[sortedTrips.length - 1].trip}`
    } else {
        // Format: [trip],[trip],[trip]
        return sortedTrips.map((trip) => trip.trip).join(',')
    }
}
